export default "__VITE_ASSET__D5yUoh4p__"